import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'medsurf-search',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent {
}
